import { render } from "./takeNotes.vue?vue&type=template&id=3b5504d6&scoped=true"
import script from "./takeNotes.vue?vue&type=script&lang=js"
export * from "./takeNotes.vue?vue&type=script&lang=js"

import "./takeNotes.vue?vue&type=style&index=0&id=3b5504d6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b5504d6"]])

export default __exports__